"use strict";
/**
 * @fileoverview Swagger API Property Proxy
 *
 * This module provides a conditional ApiProperty decorator that adapts to different environments:
 * - In webpack/frontend environments: Uses a no-op decorator to avoid importing backend dependencies
 * - In Node.js/backend environments: Uses the actual @nestjs/swagger ApiProperty decorator
 *
 * This allows shared interfaces to be used across both frontend and backend code without
 * breaking builds due to missing dependencies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiProperty = void 0;
/**
 * No-op decorator factory that accepts any arguments and does nothing.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A no-op property decorator.
 */
const noopDecorator = (..._args) => () => { };
/**
 * Logging error decorator factory that logs an error when @nestjs/swagger is missing.
 * This decorator emits a warning each time it's used, indicating that API documentation
 * won't be generated due to missing dependencies.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A property decorator that logs an error.
 */
const loggingErrorDecorator = (..._args) => () => {
    console.error("@nestjs/swagger dependency missing! ApiProperty decorator not functioning.");
};
/**
 * ApiProperty decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from @nestjs/swagger.
 */
let ApiProperty;
exports.ApiProperty = ApiProperty;
// Check if webpack is being used (indicates frontend environment).
if (typeof __webpack_require__ !== "undefined") {
    // Frontend/webpack environment - use no-op.
    exports.ApiProperty = ApiProperty = noopDecorator;
}
else {
    try {
        // Backend/Node.js environment - use real NestJS swagger decorator.
        const { ApiProperty: NestApiProperty } = require("@nestjs/swagger");
        console.log("ee-nestjs-interfaces is recording Swagger API properties.");
        exports.ApiProperty = ApiProperty = NestApiProperty;
    }
    catch {
        console.warn("ee-nestjs-interfaces is NOT recording Swagger API properties!");
        exports.ApiProperty = ApiProperty = loggingErrorDecorator;
    }
}
